<template>
  <div class="normal-layout-container">
    <div class="normal-layout-banner" :style="getBannerImageBackgroundStyle">
      <img v-if="getBannerImageForeground" :src="getBannerImageForeground" />
      <div class="normal-layout-header">
        <slot name="header"></slot>
      </div>
    </div>
    <slot name="body"></slot>
  </div>
</template>

<script>
export default {
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {
          bannerImageBackground: null,
          bannerImageForeground: null,
        }
      },
    },
  },
  computed: {
    getBannerImageBackgroundStyle () {
      let bannerImageBackground = this.layoutProps.bannerImageBackground
      return bannerImageBackground ? {
        "background-image": "url('" + bannerImageBackground + "')",
      } : null
    },
    getBannerImageForeground () {
      return this.layoutProps.bannerImageForeground
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layouts/NormalLayout.vue